export enum NewDealJourneyParams {
  objectUuid = "objectUuid",
  objectType = "objectType",
  objectName = "objectName",
}
